import React from 'react'

import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import { BlogButtonType } from '@src/Application/Types/ComponentTypes'

import { Button, Link } from './BlogButton.styled'

export const BlogButton = (props: BlogButtonType): JSX.Element => {
    const { label, link } = props

    return (
        <Grid container justifyContent="center" spacingTop={10} spacingBottom={10}>
            <Link to={link}>
                <Button>{label}</Button>
            </Link>
        </Grid>
    )
}
